import request from '@/utils/request'
import axios from 'axios'
import store from '@/store'
export function getcomparables(findRequest) {
  return request({
    url: '/valuation/SearchComparables',
    method: 'post',
    data: findRequest,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function searchComparableHistory(query) {
  return request({
    url: '/valuation/SearchComparableHistory',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function RemoveValuation(query) {
  return request({
    url: '/valuation/RemoveValuation',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function LoadValuation(query) {
  return request({
    url: '/valuation/LoadValuation',
    method: 'post',
    timeout: 60000,
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function GetSavedValuation() {
  return request({
    url: '/valuation/GetSavedValuation',
    method: 'get'
  })
}

export function saveValuation(data) {
  return request({
    url: '/valuation/SaveValuation',
    method: 'post',
    timeout: 60000,
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function exportExcelComparables(compData) {
  return axios.post(window._env_.VUE_APP_BRAINS_API + '/valuation/DownloadCurrentComparables',
    compData,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + store.state.user.token
      },
      timeout: 45000,
      responseType: 'arraybuffer'
    }
  )
}

export function DownloadGenericTableAsXlsx(arrayList) {
  return axios.post(window._env_.VUE_APP_BRAINS_API + '/valuation/DownloadGenericTableAsXlsx',
    arrayList,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + store.state.user.token
      },
      timeout: 45000,
      responseType: 'arraybuffer'
    }
  )
}

export function parseStockComparables(query) {
  return request({
    url: '/valuation/ParseStockComparables',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getCardsData(query) {
  return request({
    url: '/valuation/SearchCardsData',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getGoogleStreetViewImage(query) {
  return request({
    url: '/valuation/GetGoogleStreetViewImage',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob'
  })
}

export function downloadimage(imageUrl) {
  return request({
    url: '/UserSearch/downloadimage',
    method: 'post',
    data: imageUrl,
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob'
  })
}
